<template>
    <div class="bulkAssign">
        <div v-if="!isEmployeeAllowed">
            <NotAllowed />
        </div>
        <div v-else>
            <div class="o-main-content-area o-main-content-area-assign-adjust c-responsive-fixwidth">
                <div class="table_header_wrapper">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="pagination">
                                <h1 class="h1">Jobs / Events: <a href="javascript: void(0)" @click="backToJobDetails"> {{jobTitle}}</a><i class="fa fa-angle-right" aria-hidden="true"></i><a class="active-color" href="javascript: void(0)" @click="goToCalls('individual')">Individual Calls</a> / <a href="javascript: void(0)" @click="goToCalls('bulk')">Bulk Calls</a><i class="fa fa-angle-right" aria-hidden="true"></i> <strong>Assign</strong></h1>
                            </div>
                        </div>
                        <div class="col-md-12 text-rightt">
                            <form class="form-inline table_form_alt table_form_alt_align">

                                <div class="form-group">
                                    <label class="common-label-text">Status Level:</label>
                                    <label class="common-label-input o-custom-dropdown">
                                        <select @change="onChangeStatus()" v-model="selectedStatusId" id="selectedStatus" tabindex="2" class="form-control o-min-width select_margin_adjust">
                                            <option v-for="status in statusList" :value="status.id" :key="status.id">{{status.name}}</option>
                                            <option value="">All</option>
                                        </select>
                                        <span class="o-custom-drop-arrow" style="right: -38px;"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                    </label>
                                </div>
                                <div class="form-group">
                                    <label class="common-label-text">Sort By:</label>
                                    <label class="common-label-input o-custom-dropdown">
                                        <select @change="getEmployeesBySkill()" v-model="selectedSortType" tabindex="3" id="assign-emp-sort" class="form-control o-min-width select_margin_adjust">
                                            <option value="">- - - Select - - -</option>
                                            <option value="fname_asc">FirstLast (Employee name)</option>
                                            <option value="lname_asc">LastFirst (Employee name)</option>

                                            <option value="wishlist_asc">Wishlist Timestamp(Ascending)</option>
                                            <option value="wishlist_desc">Wishlist Timestamp (Decending)</option>

                                            <option value="participation_asc">Participation(Ascending)</option>
                                            <option value="participation_desc">Participation(Decending)</option>

                                            <option value="participation_july_june_asc">Participation July June (Ascending)</option>
                                            <option value="participation_july_june_desc">Participation July June (Decending)</option>

                                            <option value="emp_seniority">Employee Seniority (Ascending)</option>
                                            <option value="emp_seniority_desc">Employee Seniority (Decending)</option>


                                            <option value="skill_seniority">Skill Seniority (Ascending)</option>
                                            <option value="skill_seniority_desc">Skill Seniority (Decending)</option>

                                            <option value="location_asc">Location (Ascending)</option>
                                            <option value="location_desc">Location (Decending)</option>

                                            <option value="shift_total_asc">Total Shift (Ascending)</option>
                                            <option value="shift_total_desc">Total Shift (Decending)</option>

                                            <option value="shift_weekly_asc">Weekly Shift (Ascending)</option>
                                            <option value="shift_weekly_desc">Weekly Shift (Decending)</option>

                                            <option value="shift_july_june_asc">Shift July June (Ascending)</option>
                                            <option value="shift_july_june_desc">Shift July June (Decending)</option>

                                            <option value="shift_YTD_asc">Shift YTD (Ascending)</option>
                                            <option value="shift_YTD_desc">Shift YTD (Decending)</option>

                                            <option value="decline_total__asc">Decline Total (Ascending)</option>
                                            <option value="decline_total__desc">Decline Total (Decending)</option>

                                            <option value="decline_weekly_asc">Decline Weekly (Ascending)</option>
                                            <option value="decline_weekly_desc">Decline Weekly (Decending)</option>

                                            <option value="decline_july_june_asc">Decline July June (Ascending)</option>
                                            <option value="decline_july_june_desc">Decline July June (Decending)</option>

                                            <option value="decline_july_june_asc">Decline July June (Ascending)</option>
                                            <option value="decline_july_june_desc">Decline July June (Decending)</option>

                                            <option value="decline_YTD_asc">Declines YTD (Ascending)</option>
                                            <option value="decline_YTD_desc">Declines YTD (Decending)</option>

                                            <option value="conflicts_asc">Conflicts (Ascending)</option>
                                            <option value="conflicts_desc">Conflicts (Decending)</option>

                                            <option value="wishlist_seniority">Wishlist by Seniority (Ascending)</option>
                                            <option value="wishlist_seniority_desc">Wishlist by Seniority (Decending)</option>

                                            <option value="member_since_asc">Member Since (Ascending)</option>
                                            <option value="member_since_desc">Member Since (Decending)</option>

                                            <option value="date_of_hire_asc">Date of Hire (Ascending)</option>
                                            <option value="date_of_hire_desc">Date of Hire (Decending)</option>

                                            <option value="last_offer_asc">Last Offer  (Ascending)</option>
                                            <option value="last_offer_desc">Last Offer (Decending)</option>

                                            <option value="last_assigned_asc">Last Assigned  (Ascending)</option>
                                            <option value="last_assigned_desc">Last Assigned (Decending)</option>

                                            <option value="last_confirmed_asc">Last Confirmed  (Ascending)</option>
                                            <option value="last_confirmed_desc">Last Confirmed (Decending)</option>
                                        </select>
                                        <span class="o-custom-drop-arrow" style="right: -54px;"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                    </label>
                                </div>
                            </form>

                            <ul class="o-filter-area">

                                <li class="o-search-field">
                                    <div class="input-group stylish-input-group">
                                        <input type="text" class="form-control table_search" placeholder="Name,Zip,City" v-on:keyup="updateValue" v-model="searchBoxvalue" tabindex="4" id="assign-emp-search">
                                        <span class="input-group-addon">
                                            <button @click="searchBoxvalue = ''; updateValue()">
                                                <span class=""><i class="fa fa-times" aria-hidden="true"></i></span>
                                            </button>
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="c-common-space o-top-heading c-responsive-fixwidth table_sub_left no-margin table_tagline">
                        <p class="h5-v1"><span>{{selectedCallSkillname+' for '+getDate(callStartTime)}}:</span> {{" "+getTime(callStartTime)+" - "+getTime(callEndTime)}}</p>
                    </div>
                </div>
            </div>

            <div class="o-ndividualArea c-responsive-fixwidth">
                <div class="o-ndividualTable assigntab" style="padding-top: 0px;">
                    <div class="extra-list-table-outer table_main_content">
                        <div class="tbl-header">
                            <div class="o-calls-table bulk-table-list c-radius3 table_header_black table_1">
                                <div class="calls-table-row">
                                    <div class="calls-table-cell tcell_1">
                                        <div class="table-td-border-right">
                                            <div class="calls-table-cell-inner-table">
                                                <div class="table_heading th_cell_1">List<!-- <span class="fa fa-sort fa-position" aria-hidden="true"></span> --></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="calls-table-cell tcell_1">
                                    </div>

                                    <dynamicHeader v-for="(item, index) in callAssigmentSettings" :client="client" :columnLabel="item" :sortType="selectedSortType" :key="index"></dynamicHeader>
                                    <div v-if="job && job.hts_flag" class="calls-table-cell tcell_1">
                                        <div class="table-td-border-right">
                                            <div class="calls-table-cell-inner-table">
                                                <div class="table_heading th_cell_6">HTS<!-- <span class="fa fa-sort fa-position" aria-hidden="true"></span> --></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="calls-table-cell tcell_8">
                                        <div class="table-td-border-right border-right-none">
                                            <div class="calls-table-cell-inner-table">
                                                <div class="table_heading th_cell_6">Action<!-- <span class="fa fa-sort fa-position" aria-hidden="true"></span> --></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <v-infinite-scroll
                            id="page-data-focus"
                            ref="scrollContainer"
                            tabindex="1"
                            :loading="loading"
                            :offset="100"
                            class="tbl-content"
                            @bottom="onPageChangeScrollDown"
                            @top="onPageChangeScrollUp"
                        >
                            <div v-for="(employee, row) in employees" :key="employee.id" :style="{'border': '2px solid '+employee.link_color, 'box-shadow': '0px 0px 5px 0px '+employee.link_color}" class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-radius3 table_1">
                                <div class="calls-table-row">
                                    <div class="calls-table-cell tcell_1 calls-table-alphabet" :style="{'background-color': employee.link_color}">
                                        <span>{{getStatusName(employee.status_name)}} <br/> ({{employee.status_priority}})</span>
                                    </div>
                                    <div class="calls-table-cell tcell_1">
                                        <div class="o-post-logged o-post-logged--table-user">
                                                <div class="display-inline">
                                                    <span class="global-skill-display" v-if="employee.global_skills">GS</span>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="calls-table-cell tcell_1">
                                        <div class="o-post-logged o-post-logged--table-user">
                                        <div class="o-user-profile-img" :id="'scrollTop'+row">
                                            <img v-if="employee.image != '' && employee.image != 'NULL'" :src="(employee.image)"  id='img-upload'/>
                                            <img v-if="employee.image == '' || employee.image == 'NULL'" src="static/assets/images/user1.png" id='img-upload'/>
                                        </div>
                                        </div>
                                    </div>
                                    
                                    <dynamicColumns v-for="(item, index) in callAssigmentSettings" :employee="employee" :columnLabel="item" :client="client" :selectedSortType="selectedSortType" :callStartTime="callStartTime" :callEndTime="callEndTime" :userDateFormat="userDateFormat" :isSteward="isSteward" :isDispatcher="isDispatcher" :userTimeFormat="userTimeFormat" :allow-reassign="false" :key="index" @unassign-reassign-here="unassignReassignHere"></dynamicColumns>
                                    <div v-if="job && job.hts_flag" class="calls-table-cell tcell_1 ">
                                        <div class="table-td-border-right" v-if="(employee.bookings.length==0 && !recurringUnavailability(employee.available_times) && !checkVacationWithinCall(employee.vacations) && !getCallOutStatus(employee.call_actions) && !getDeclineStatus(employee.call_actions) && employee.hts.length==0)">
                                            <a @click="ckeckHTS(employee.id)"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                    <div class="calls-table-cell tcell_8">
                                        <div :class="{'isDisabled':!getPower('callAssign')}">
                                            <!-- #1671 — selectability = real PER-DAY availability, NOT the hts_flag.
                                                 GREEN / advisory (HTS orange hold, offered-elsewhere) → assignable;
                                                 HARD-unavailable (vacation / recurring / confirmed-elsewhere / call-out /
                                                 declined) → blocked. assignHardBlocked() reads the per-day resolver, so a
                                                 green-on-this-day worker with an envelope vacation is no longer falsely
                                                 blocked. Plus employee.assign_button (MUA-block) + the callAssign
                                                 permission (div above). Same fix in bulk.vue. -->
                                            <a href="javascript: void(0)" :id="'btn-'+employee.id" @click="checkOtherBookingConflict(employee)" :class="(!assignHardBlocked(employee) && employee.assign_button) ? 'c-common-btn c-common-btn--small c-common-btn--inverse-icon-green' : 'c-common-btn c-common-btn--small c-common-btn--inverse-icon-green isDisabled'">Assign</a>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="loading" v-loading="loading" class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3 table_1" style="height: 50px;">
                                <div class="calls-table-row">
                                    <div class="calls-table-cell" style="height: 60px;">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="employees.length<=0 && apiData && !loading" v-loading="loading" class="o-calls-table extra-list-table bulk-table-list c-common-gradient c-common-box-shadow c-radius3 table_1" style="height: 50px;">
                                <div class="calls-table-row">
                                    <div class="calls-table-cell" style="height: 60px;">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <div>Empty Employee List</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-infinite-scroll>
                    </div>

                    <div class="el-pagination-assign">
                        <!-- layout="total, sizes, prev, pager, next, jumper" -->
                        <!-- :page-sizes="[100, 200, 300, 400]" -->
                       <el-pagination
                            :current-page.sync="currentPage"
                            :page-size="pageSize"
                            :total="totalLimit"
                            layout="prev, pager, next"
                            @current-change="onPageChange"
                        />
                    </div>
                </div>
            </div>

            <div v-if="openOtherConflictsModal">
                <modal name="otbConflictPop"  height="auto" :scrollable="false" class="modal-dialog modal-sm modal--custom">
                    <div  tabindex="-1" role="dialog">
                    <div  role="document">
                        <div class="modal-content o-common-modal-content">
                            <div class="modal-header text-center">
                                <button @click="closeOtbConflictPop()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 class="modal-title">WARNING !</h1>
                            </div>
                            <div class="modal-body">
                                    <div class="obt-conflict-body">
                                        Selecting this user will create the opportunity for a 2x Booking in another client.
                                        Proceed with Caution and make direct contact with the employee!
                                    </div>
                                </div>

                                <div class="modal-footer text-center">
                                    <a id="btn-bulk-assign-modal" href="javascript: void(0)" @click="closeOtbConflictPop()" class="c-common-btn c-common-btn--small obt-modal-cancel-btn"> Cancel</a>
                                    <a id="btn-bulk-assign-modal" href="javascript: void(0)" @click="proceedWithConflict(selectedEmployeeID)" class="c-common-btn c-common-btn--small obt-modal-proceed-btn">Proceed</a>
                                </div>

                        </div>
                    </div>
                </div>
                </modal>
            </div>
        </div>
    </div>
</template>
<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import dynamicColumns from './dynamicColumns';
    import dynamicHeader from './dynamicHeader';
    import { mapGetters, mapActions} from 'vuex';
    import { global } from '../../../global.js';
    import service from '../../../services.js';
    import { bus } from '../../../main';
    import NotAllowed from '@/components/NotAllowed';
    let timeout = null;
    export default {
        components: {
            'dynamicHeader': dynamicHeader,
            'dynamicColumns': dynamicColumns,
            'NotAllowed': NotAllowed
        },

        data() {
            return {
                isEmployeeAllowed: true,
                isSteward: 0,
                isDispatcher: 0,
                timerState: null,
                polling:null,
                currentPage: 1,
                lastLoadedPage: 0,
                isFirstPageLoad: false,
                totalLimit:0,
                pageSize:100,
                empProfile: '',
                getBaseURL: '',
                selectedSortType: 'seniority',
                employees: [],
                storeMore: [],
                nextPageUrl: '',
                statusList: [],
                selectedStatusId: '',
                tempStatus: '',
                jobList: [],
                turnoverTime: '',
                customField1: '',
                customField2: '',
                showCustom: '',
                callAssigmentSettings:'',
                map_name: "googleMap",
                addresses:'',
                jobTitle :'',
                loading:true,
                apiData:false,
                searchBoxvalue:'',
                client:{},
                job:null,
                userDateFormat: null,
                userTimeFormat:null,
                selectedEmployeeID: null,
                openOtherConflictsModal: false,
                scrollType: null,
                isPaginationChange: false,
                scrollDirection: null
            }
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                callId: 'selectedCallId',
                callStartTime: 'callStartTime',
                callEndTime: 'callEndTime',
                skillId: 'skillId',
                callStatus: 'callStatus',
                employeeId: 'employeeId',
                callDate: 'callDate',
                selectedCallSkillname:'selectedCallSkillname',
                getAssignPageStatus: 'getAssignPageStatus',
                getJob:'getJobDetails',
                clientDetails:'clientDetails',
                employeeStatusList:'employeeStatusList',
            }),
            deviceDetector() {
                let userAgent = navigator.userAgent.toLowerCase();
                const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
                return("desktop" != check ? !0 : !1);
            },
        },

        methods: {
            async checkStewardSkill(){
                this.isSteward = 0;
                await service
                .get("employee/" + this.employeeId + "/checkSkill", {
                    Authorization: this.userToken,
                    "cs3-context-role": this.userRole,
                    "cs3-context-clientId": this.userClientID,
                })
                .then((res) => {
                    this.isSteward = res.data.result;
                    this.$forceUpdate();
                })
                .catch((err) => {
                    this.isSteward = 0;
                    this.$Progress.fail();
                });
            },
            async checkDispatcherSkill(){
                this.isDispatcher = 0;
                await service
                .get("employee/" + this.employeeId + "/checkDispatchBySkill", {
                    Authorization: this.userToken,
                    "cs3-context-role": this.userRole,
                    "cs3-context-clientId": this.userClientID,
                })
                .then((res) => {
                    this.isDispatcher = res.data.result;
                    this.$forceUpdate();
                })
                .catch((err) => {
                    this.isDispatcher = 0;
                    this.$Progress.fail();
                });
            },
            getEmpDetails() {
                // console.log(this.employeeId);
                this.$Progress.start();
                service.get('employee/' + this.employeeId, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.userDateFormat = res.data.result.date_format;
                    this.userTimeFormat = res.data.result.time_format;
                    // console.log(this.userDateFormat,this.userTimeFormat)
                }).catch((err) => {
                    console.log(err);
                });
            },
            onKeyDown(e){
                console.log(e);
                this.onPageChangeScroll();
            },
            getStatusName(name){
                let temp = name.substring(0, 3);
                return temp.toUpperCase();
            },

            // onPageChangeScrollUp(){
            //     if(this.isFirstPageLoad && this.employees.length && this.currentPage>1){
            //         this.lastLoadedPage = this.currentPage;
            //         this.currentPage = this.currentPage-1;
            //         this.isFirstPageLoad = false;
            //         setTimeout(()=>{
            //             this.isFirstPageLoad = true;
            //         }, 200);
            //         this.scrollType = "up";
            //         // this.onPageChange(this.currentPage);
            //     }
            // },

            // onPageChangeScrollDown(){
            //     let total = this.totalLimit/this.pageSize;
            //     if(this.isFirstPageLoad && this.employees.length && this.currentPage<=total){
            //         this.lastLoadedPage = this.currentPage;
            //         this.currentPage = this.currentPage+1;
            //         this.isFirstPageLoad = false;
            //         setTimeout(()=>{
            //             this.isFirstPageLoad = true;
            //         }, 200);
            //         // this.onPageChange(this.currentPage);
            //     }
            // },

            //  onPageChange(val){
            //     const isMobile = this.deviceDetector;
            //     let tempEmpList = this.storeMore;
            //     // console.log(this.currentPage);
            //     let buffer = isMobile ? 6 : 4;
            //     let end = (this.pageSize * this.currentPage);
            //     let start = end - this.pageSize;

            //     start = start - buffer;
            //     if(start < 0){
            //         start = 0
            //     }
            //     end = end + buffer;

            //     if(end > this.totalLimit){
            //         end =  this.totalLimit;
            //     }

            //     this.employees = this.storeMore.slice(start, end-1);
            //     //  const firstScrollTo = scroller();

            //     if(this.currentPage >= this.lastLoadedPage){
            //         $('#page-data-focus').scrollTop($('#scrollTop2').scrollTop());
            //         this.lastLoadedPage = this.currentPage;
            //         if(this.currentPage == this.lastLoadedPage){
            //             this.employees = this.storeMore.slice(start, end+1);
            //         }
            //     }else{
            //         let last_position = this.totalLimit % this.pageSize;
            //         let position = "";
            //         // console.log(this.lastLoadedPage);
            //         if(this.scrollType == 'up' && this.lastLoadedPage == Math.ceil(this.totalLimit/this.pageSize)) {
            //             position = $('#scrollTop'+last_position).offset();
            //             $('#page-data-focus').scrollTop(position.top - $('#scrollTop'+last_position).scrollTop());
            //         } else {
            //             position = $('#scrollTop98').offset();
            //             $('#page-data-focus').scrollTop(position.top - $('#scrollTop98').scrollTop());
            //         }
            //         // console.log("position:",+position);
            //         this.lastLoadedPage = this.currentPage;
            //     }
            //     this.scrollType = null;
            // },

            onPageChangeScrollUp(){
                if (this.loading || this.ignoreScrollEvents) return;
                if (this.currentPage <= 1) return; // first page
                this.loading = true;
                this.isPaginationChange = true;
                this.scrollDirection = 'up';
                this.currentPage--;
                this.updatePagedData();
                this.loading = false;
            },

            updatePagedData() {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = start + this.pageSize;

                if (this.isPaginationChange) {
                    // On pagination click, replace with new slice
                    this.employees = this.storeMore.slice(start, end);
                } else if (this.scrollDirection === 'down') {
                    const newItems = this.storeMore.slice(start, end);

                    // Filter to only add items not already present
                    const existingIds = new Set(this.employees.map(e => e.id));
                    const filteredNewItems = newItems.filter(item => !existingIds.has(item.id));

                    // Only concat if there are new items (protects against double fire at last page)
                    if (filteredNewItems.length > 0) {
                    this.employees = this.employees.concat(filteredNewItems);
                    }
                    // Else: do NOT modify employees, prevents duplicates
                } else if (this.scrollDirection === 'up') {
                    // Only implement if you use upward infinite scroll
                    // ...similar logic as above, with prepending
                }

                this.isPaginationChange = false;
                this.scrollDirection = null;
            },
            
            onPageChangeScrollDown(){
                if (this.loading) return;

                // Compute total number of pages:
                const totalPages = Math.ceil(this.totalLimit / this.pageSize);
                if (this.currentPage >= totalPages) return; // do NOT increment past last page

                this.loading = true;
                this.scrollDirection = 'down';
                this.isPaginationChange = false;
                this.currentPage++;
                this.updatePagedData();
                this.loading = false;
            },

            onPageChange(page){
                if (this.loading) return;

                this.loading = true;
                this.isPaginationChange = true;
                this.scrollDirection = null;
                this.currentPage = page;
                // Ignore scroll events during programmatic scrollTop setting
                this.ignoreScrollEvents = true;

                this.updatePagedData();

                this.$nextTick(() => {
                    if (this.$refs.scrollContainer) {
                        this.$refs.scrollContainer.$refs.container.scrollTop = 0;
                    }
                    setTimeout(() => {
                        this.ignoreScrollEvents = false; // re-enable scroll handling after short delay
                    }, 100);
                    
                    this.loading = false;
                });
            },
            
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },

            getCallActionByType(call_action, type){
                let declines = [], passes = [], timeouts = [], callouts = [];
                if(call_action && call_action.length){
                    call_action.forEach(call => {
                        switch(call.action_name){
                            // decline Call
                            case 'Declined':
                                declines.push(call);
                            break;
                            // pass call
                            case 'Passed':
                                passes.push(call);
                            break;
                            // call out
                            case 'Call Out':
                                callouts.push(call);
                            break;
                            // Call time out
                            case 'Timed Out':
                                timeouts.push(call);
                            break;
                            default:
                                // console.log('call Action not found switch 1')
                        }
                    });
                }
                switch(type){
                    // decline Call
                    case 'Declined':
                        return declines;
                    break;
                    // pass call
                    case 'Passed':
                        return passes;
                    break;
                    // call out
                    case 'Call Out':
                        return callouts;
                    break;
                    // Call time out
                    case 'Timed Out':
                        return timeouts;
                    break;
                    default:
                        // console.log('call Action not found switch 2')
                }
                return [];
            },

            updateValue(){
                this.selectedStatusId = "";
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if(this.searchBoxvalue.length==0) {
                        document.getElementById('page-data-focus').focus();
                        this.selectedStatusId = this.tempStatus
                    }
                    this.getEmployeesBySkill();
                }, 1000);
            },
            ckeckHTS(emp_id){
                service.get('employee/checkEmployeeAvailability', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'jobId':atob(this.$route.params.id),
                    'employeeId': emp_id
                }).
                then((res) => {
                    // let avaliable='';
                    // let notAvaliable='';
                    // console.log(res);
                    if(res.data.result.status){
                        this.$notify({
                            title: 'Success',
                            message: res.data.result.message,
                            type: 'success'
                        });
                    }else{
                        this.$notify({
                            title: 'Error',
                            message: res.data.result.message,
                            type: 'error'
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            backToJobDetails(){
                this.$router.push({
                    path: `/jobDetails/`+this.$route.params.id
                });
            },

            // getDeclineStatus(data){
            //     if(data.length>0){
            //         return true;
            //     }else{
            //        return false;
            //     }
            // },
            getDeclineStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Declined");
                if((data.length>0 || Object.keys(data).length>0)){
                    return true;
                }
                return false;
            },
            getCallOutStatus(call_actions){
                let data = this.getCallActionByType(call_actions, "Call Out");
                if ((data.length > 0 || Object.keys(data).length>0)) {
                    return true;
                }
                return false;
            },
            goToCalls(callType) {
                this.$store.dispatch('setSelectedCallList', callType);
                this.$router.push({
                    path: `/viewCalls/`+this.$route.params.id
                });
            },

            bulkAssign() {
                this.$router.push('bulkAssign');
            },

            employeeSummary() {
                this.$modal.show('employeeSummary');
            },

            hideModal() {
                this.$modal.hide('employeeSummary');
            },

            getTime(dateTime) {
                return dateTimeConvert.localTime(dateTime);
            },
            getDate(dateTime) {
                return dateTimeConvert.localDate(dateTime, 'MMMM D, YYYY');
            },

            // #1671 — per-day HARD-unavailability that legitimately blocks the assign
            // control. Sourced from the #1661 PER-DAY resolver (employee.conflict) for
            // vacation / recurring / confirmed-elsewhere — NOT the envelope-loaded
            // employee.vacations/bookings, whose "any vacation in the array" check falsely
            // blocked GREEN-on-this-day workers on month-long HTS jobs (the actual bug).
            // Plus per-call call-out / declined. Advisory states (green, HTS orange hold,
            // offered-elsewhere) are NOT blocked -> selectable. HTS informs; it never blocks.
            assignHardBlocked(employee){
                const c = employee && employee.conflict;
                const reasons = c ? [(c.primary && c.primary.reason)].concat((c.others || []).map(o => o && o.reason)) : [];
                // #1690 T2 — booked_confirmed_elsewhere is NO LONGER a blanket hard-block
                // (Ed Q5: defer to MUA). A worker confirmed elsewhere is assignable/clearable
                // here UNLESS their status group carries the MUA block (block_mua_bookings,
                // cross-client), which the backend already enforces via employee.assign_button
                // (=0 for an MUA-blocked cross-client booking). The other-booking warning
                // (checkOtherBookingConflict → otbConflictPop) still fires on click. Vacation/RU
                // stay hard (nothing to unassign).
                const hardResolver = reasons.indexOf('vacation') !== -1
                    || reasons.indexOf('recurring') !== -1;
                return hardResolver
                    || this.recurringUnavailability(employee.available_times)
                    || this.getCallOutStatus(employee.call_actions)
                    || this.getDeclineStatus(employee.call_actions)
                    // #1690 T5b — a no-show / sent-home is a 24h block: no assign tool.
                    || this.getNoShowSentHomeStatus(employee.call_actions);
            },
            // #1690 T5b — worker has a no-show / sent-home logged (the re-offerable
            // "no" family; yellow pill). Blocks the assign tool for the block window.
            getNoShowSentHomeStatus(call_actions){
                if (!call_actions || !call_actions.length) return false;
                return call_actions.some(c => c && (c.action_name === 'No-show' || c.action_name === 'Sent Home'));
            },
            checkThisClickCooking(bookings){
                let status = false;
                for(let i=0; i<bookings.length; i++){
                    if(bookings[i].client_id == this.userClientID) {
                        status = true;
                    }
                }
                return status;
            },

            checkOtherBookingConflict(emp) {

                let status = false;

                for(let i=0; i<emp.bookings.length; i++){
                    if(emp.bookings[0].client_id != this.userClientID) {
                        status = true;
                    }
                }
                if(status==true) {
                    // console.log("check if")
                    this.selectedEmployeeID = emp.id;
                    this.$modal.show("otbConflictPop");
                    this.openOtherConflictsModal=true;
                    this.$forceUpdate();
                }else {
                    // console.log("check Else")
                    // this.$modal.hide("otbConflictPop");
                    this.closeOtbConflictPop();
                    this.selectedEmployeeID = null;
                    this.assignEmployee(emp.id);
                }
            },

            closeOtbConflictPop() {
                this.$modal.hide("otbConflictPop");
                this.openOtherConflictsModal = false;
            },

            proceedWithConflict(emp_id){
                // console.log("Proceed Conflict");
                this.closeOtbConflictPop();
                this.assignEmployee(emp_id);
            },


            // #1661 — recoverable red (worker booked/offered on ANOTHER call elsewhere):
            // unassign that elsewhere call, then assign the worker to THIS call. The
            // elsewhere call id rides in the resolver's conflict detail (call_id).
            async unassignReassignHere({ employee, conflict }) {
                var detail = conflict && conflict.primary && conflict.primary.detail;
                var elsewhereCallId = detail && detail.call_id;
                if (!elsewhereCallId) {
                    this.$notify.error({
                        title: 'Cannot reassign',
                        message: 'The conflicting booking could not be identified. Please refresh and try again.'
                    });
                    return;
                }
                var label = detail.job_number
                    ? ('#' + detail.job_number + (detail.job_title ? ' ' + detail.job_title : ''))
                    : 'another job';
                this.$confirm(
                    'This will unassign this worker from ' + label + ' and assign them to this call. Continue?',
                    'Unassign & reassign here',
                    { confirmButtonText: 'Unassign & reassign', cancelButtonText: 'Cancel', type: 'warning' }
                ).then(async () => {
                    try {
                        await service.del('call/' + elsewhereCallId + '/assign', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'userId': this.userID
                        });
                        // Reuse the existing assign flow — it already handles the #1602
                        // HTS future-conflict soft gate + the grid refresh on success.
                        await this.assignEmployee(employee.id);
                    } catch (err) {
                        console.log(err);
                        this.getEmployeesBySkill();
                        this.$notify.error({
                            title: 'Error',
                            message: 'Could not unassign the existing booking. Please refresh and try again.'
                        });
                    }
                }).catch(() => {});
            },

            async assignEmployee(employeeId, override = false) {
                var employees = this.employees;
                this.employees = [];
                this.loading = true;
                this.closeOtbConflictPop();
                // this.loading = true;
                $("#btn-"+employeeId).addClass("deactivate-btn");
                $("#btn-"+employeeId).addClass("deactivate-btn");
                await service.put('call/' + this.callId + '/assign', {
                        'employee_id': employeeId,
                        'status_id': this.callStatus,
                        'user_id': this.userID,
                        // #1602 — set on the retry after the dispatcher confirms the
                        // "Future Conflict Detected" modal for an HTS-job assign.
                        'override': override ? 1 : 0,
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).then((res) => {
                    this.employees = employees;
                    this.loading = false;
                    if(res.data.status_code == "1"){
                        // this.$modal.hide("otbConflictPop");
                        this.$notify({
                            title: 'Success',
                            message: 'Employee assigned Successfully.',
                            type: 'success'
                        });
                        this.$router.push({
                            path: `/viewCalls/`+ this.$route.params.id
                        });
                    }else{
                        this.getEmployeesBySkill();
                        this.selectedEmployeesToAssign = [];
                        this.$notify({
                            title: 'Error',
                            message: res.data.status_message,
                            type: 'error'
                        });
                    }
                }).catch((err) => {
                    this.employees = employees;
                    this.loading = false;
                    $("#btn-"+employeeId).removeClass("deactivate-btn");
                    $("#btn-"+employeeId).removeClass("deactivate-btn");

                    // #1602 — HTS assign-time envelope soft gate. On assigning an HTS
                    // job over a FUTURE vacation/RU/booking in the run, the backend
                    // returns 409 { result: { future_conflict, conflicts[] } }. Show
                    // the soft-gate modal; on Continue, re-post with override=1.
                    var fc = err && err.response && err.response.data && err.response.data.result;
                    if (fc && fc.future_conflict) {
                        var types = (fc.conflicts || []).join(', ');
                        this.$confirm(
                            'This worker has a future conflict' + (types ? ' (' + types + ')' : '') + ' across this run. Continue booking?',
                            'Future Conflict Detected',
                            { confirmButtonText: 'Continue', cancelButtonText: 'Cancel', type: 'warning' }
                        ).then(() => {
                            this.assignEmployee(employeeId, true);
                        }).catch(() => {
                            this.getEmployeesBySkill();
                        });
                        return;
                    }

                    console.log(err);
                    this.$notify({
                        title: 'Error',
                        message: 'Employee already booked please refresh your current page.',
                        type: 'error'
                    });
                })
                // console.log("assignEmployee");
            },

            onChangeStatus() {
                this.getEmployeesBySkill();
                this.tempStatus = this.selectedStatusId;
                this.$store.dispatch('setAssignPageStatus', {
                    'uid': this.userID,
                    'status': this.selectedStatusId
                });
                //console.log('getAssignPageStatus', this.getAssignPageStatus);
            },

            async getEmployeesBySkill() {
                this.employees=[];
                this.storeMore=[];
                this.loading=true;
                this.apiData=false;
                // let scrollPositionX = window.pageXOffset;
                // let scrollPositionY = window.pageYOffset;
                this.$Progress.start();
                await service.get('call/' + this.callId + '/getEmployeesBySkill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'employee-status-id': this.selectedStatusId,
                    'sort-type': this.selectedSortType,
                    'search': this.searchBoxvalue,
                    'jobId':atob(this.$route.params.id),
                })
                .then((res) => {
                    this.loading=false;
                    this.apiData=true;
                    // console.log('getEmployeesBySkill', res);
                    this.nextPageUrl = null;
                    this.storeMore= res.data.result;
                    this.totalLimit = res.data.result?res.data.result.length:0;
                    this.currentPage = 1;
                    // this.onPageChange(1);
                    if(this.totalLimit <= this.pageSize){
                        this.employees = this.storeMore;
                    }else{
                        this.onPageChange(1);
                    }
                    // console.log(scrollPositionX, scrollPositionY);
                    // window.scrollTo(scrollPositionX, scrollPositionY);
                    // document.body.scrollPositionY;

                    setTimeout(()=>{
                        this.isFirstPageLoad = true;
                        // console.log('isFirstPageLoad', this.isFirstPageLoad);
                    }, 5000);
                    this.$Progress.finish();
                    //console.log(this.employees);
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading=false;
                    this.apiData=true;
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
            },

            recurringUnavailabilityCheck(unavailability_list) {
                let flag = false;
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            console.log(unavailabilityList1[j]);
                            var temp = unavailabilityList1[j];

                            var unavailabilityStart = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var unavailabilityEnd = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';

                            let isOverNightUnavailability = moment(unavailabilityStart,'YYYY-MM-DD HH:mm:ss').isAfter(moment(unavailabilityEnd,'YYYY-MM-DD HH:mm:ss'));
                            if(isOverNightUnavailability) {
                                console.log("check0");
                                if(unavailabilityStart.split(' ')[0] == unavailabilityEnd.split(' ')[0]) {  //Check same date or not
                                    unavailabilityEnd = moment(unavailabilityStart, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");  // add 1 day
                                }
                                console.log(weekDaysNames[i]);
                                if((moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) || (moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]) || (moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) || (moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1])) {
                                // if(this.callStartTime.split(' ')[0] == this.callEndTime.split(' ')[0]) {
                                    if(this.callStartTime.split(' ')[0] == unavailabilityStart.split(' ')[0]) {
                                        console.log("Check1");
                                        console.log(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.callStartTime, this.callEndTime);
                                        return flag;
                                    }else if(this.callStartTime.split(' ')[0] == unavailabilityEnd.split(' ')[0]) {
                                        console.log("Check2");
                                        console.log(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.callStartTime, this.callEndTime);
                                        return flag;
                                    } else if(this.callEndTime.split(' ')[0] == unavailabilityStart.split(' ')[0]) {
                                        console.log("Check3");
                                        console.log(moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.callStartTime, this.callEndTime);
                                        return flag;
                                    }else if(this.callEndTime.split(' ')[0] == unavailabilityEnd.split(' ')[0]) {
                                        console.log("Check4");
                                        console.log(moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                        flag = dateTimeConvert.dateCheck(unavailabilityStart,unavailabilityEnd, this.callStartTime, this.callEndTime);
                                        return flag;
                                    }
                                }
                                console.log(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                console.log("Conditions failed");
                            }
                        }
                    }
                }
                // HillsPU
                return flag
            },

            recurringUnavailability(unavailability_list) {
                var flag=false;
                let weekDaysNumbers = ["1","2","3","4","5","6","7"];
                let weekDaysNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    for(let i=0; i<weekDaysNumbers.length; i++) {
                        let unavailabilityList1=unavailabilityList[weekDaysNumbers[i]];
                        // console.log(unavailabilityList1);
                        for(var j=1; j<=Object.keys(unavailabilityList1).length; j++){
                            // console.log(unavailabilityList1[j])
                            var temp = unavailabilityList1[j];
                            var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                            // console.log("start: ",start);
                            // console.log("end: ",end);

                            let isOvernightUnavailability = moment(start,'YYYY-MM-DD HH:mm:ss').isAfter(moment(end,'YYYY-MM-DD HH:mm:ss'));

                            if(isOvernightUnavailability) {
                                end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");
                                let day1UnavailabilityStart = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay1UnavailabilityEnd = moment(start, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '23:59:59';
                                let day1UnavailabilityEnd = moment(tempDay1UnavailabilityEnd, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let tempDay2UnavailabilityStart = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD") + ' ' + '00:00:00';
                                let day2UnavailabilityStart = moment(tempDay2UnavailabilityStart, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");
                                let day2UnavailabilityEnd = moment(end, 'YYYY-MM-DD HH:mm:ss').format("YYYY-MM-DD HH:mm:ss");

                                flag = this.checkCallDateUnavailability(day1UnavailabilityStart, day1UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[i],temp);
                                if(flag) return flag;

                                let dayIndex = i;
                                if(i==6) dayIndex=-1;

                                // #1680 — an overnight RU window's DAY-1 portion belongs to its
                                // OWN weekday (already checked above under weekDaysNames[i]); only
                                // the genuine DAY-2 spillover (00:00 → wrap) carries the next-day
                                // label. The removed check re-tested the day-1 range under the
                                // next-day label, so e.g. a Friday ["04:55","01:00"] block made a
                                // Saturday daytime call unselectable (green tile, no checkbox).
                                // Now matches backend RecurringUnavailabilityCheck.
                                flag = this.checkCallDateUnavailability(day2UnavailabilityStart, day2UnavailabilityEnd, this.callStartTime, this.callEndTime, weekDaysNames[dayIndex+1],temp);
                                if(flag) return flag;
                                // console.log(end, moment(end,'YYYY-MM-DD HH:mm:ss').format('dddd'));
                                // end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");
                                // // console.log(end, moment(end,'YYYY-MM-DD HH:mm:ss').format('dddd'));
                                // if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                //     flag = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                //     if(flag) return flag;
                                // }
                                // if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]) {
                                //     flag = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                //     if(flag) return flag;
                                // }
                                // if(moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]){
                                //     flag = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                //     if(flag) return flag;
                                // }
                                // if(moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]){
                                //     flag = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                //     if(flag) return flag;
                                // }
                                // console.log("check1");
                                // if(start.split(' ')[0] == end.split(' ')[0]) {  //Check same date or not
                                //     console.log("check2")
                                //     end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");  // add 1 day
                                // }
                                // if(this.callStartTime.split(' ')[0] == this.callEndTime.split(' ')[0]) {
                                //     console.log("CHECK-3");
                                //     if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                //         console.log("check4");
                                //         console.log(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i]);
                                //         let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                //         return flag1;
                                //     }else {
                                //         console.log("else check4");
                                //         if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]) {
                                //             console.log("check5");
                                //             console.log(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd'),weekDaysNames[i+1]);
                                //             start = moment(end, 'YYYY-MM-DD HH:mm:ss').add(-1, "d").format("YYYY-MM-DD HH:mm:ss");
                                //             let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                //             return flag1;
                                //         }
                                //     }
                                // } else {
                                //     end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                                //     // if(start.split(' ')[0] == end.split(' ')[0]) {
                                //     //     // console.log("check2");
                                //     //     end = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("YYYY-MM-DD HH:mm:ss");
                                //     // }
                                //     if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                //         // console.log("Check3");
                                //         let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                //         return flag1;
                                //     }else if(moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i+1]){
                                //         // console.log("Check4");
                                //         let flag1 = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                //         return flag1;
                                //     }
                                // }

                                // let overNightUnavailabilityEnd = moment(end, 'YYYY-MM-DD HH:mm:ss').add(1, "d").format("DD-MM-YYYY");

                                // overNightUnavailabilityEnd = overNightUnavailabilityEnd + ' '+temp[1]+':00';

                                // if(weekDaysNames[i] == (moment(overNightUnavailabilityEnd,'YYYY-MM-DD HH:mm:ss').format('dddd'))) {
                                //     let flag1 = dateTimeConvert.dateCheck(start,overNightUnavailabilityEnd, this.callStartTime, this.callEndTime);
                                //     return flag1;
                                // }
                            }else {
                                if((moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                                    // console.log("overnight Call:", weekDaysNames[i]);
                                    let day1CallStart = moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let tempDay1CallEnd =  moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    // console.log(day1CallStart,day1CallEnd);


                                    let tempDay2CallStart =  moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    let day2CallEnd = moment(this.callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                                    // console.log(day2CallStart,day2CallEnd);

                                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]){
                                        // console.log("Check2");
                                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                                        if(flag) return flag;
                                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                                        if(flag) return flag;
                                    }
                                }else {
                                    // console.log("Single");
                                    if(moment(this.callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == weekDaysNames[i]) {
                                        flag = dateTimeConvert.dateCheck(start,end, this.callStartTime, this.callEndTime);
                                        // console.log("check1 - " + i, weekDaysNames[i]);
                                        if(flag) return flag;
                                    }
                                }
                            }

                        }
                    }
                }
                return flag;
            },

            checkCallDateUnavailability(start, end, callStartTime, callEndTime, day,temp) {
                let flag = false;
                if((moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') != moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'))) {
                    let day1CallStart = moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let tempDay1CallEnd =  moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '23:59:59'
                    let day1CallEnd = moment(tempDay1CallEnd,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    let tempDay2CallStart =  moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') + ' ' + '00:00:00'
                    let day2CallStart = moment(tempDay2CallStart,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                    let day2CallEnd = moment(callEndTime,'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

                    if(moment(day1CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day){
                        start = day1CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day1CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day1CallStart, day1CallEnd);
                        if(flag) return flag;
                    }else if(moment(day2CallStart,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        start = day2CallStart.split(' ')[0]+' '+temp[0]+':00';
                        end = day2CallStart.split(' ')[0]+' '+temp[1]+':00';
                        flag = dateTimeConvert.dateCheck(start,end, day2CallStart, day2CallEnd);
                        if(flag) return flag;
                    }
                }else {
                    console.log(day, start, end, callStartTime, callEndTime);
                    if(moment(callStartTime,'YYYY-MM-DD HH:mm:ss').format('dddd') == day) {
                        flag = dateTimeConvert.dateCheck(start,end, callStartTime, callEndTime);
                        if(flag) return flag;
                    }
                }
                return flag;
            },

            recurringUnavailability1(unavailability_list){
                let flag=false;
                if(unavailability_list && Object.keys(unavailability_list).length){
                    let unavailabilityList = JSON.parse(unavailability_list);
                    let dayNum1=moment(this.callStartTime).format('d');

                    dayNum1=Number(dayNum1)+1;
                    let unavailabilityList1=unavailabilityList[dayNum1];
                    for(var i=1; i<=Object.keys(unavailabilityList1).length; i++){
                        var temp = unavailabilityList1[i];
                        var start = this.callStartTime.split(' ')[0]+' '+temp[0]+':00';
                        var end = this.callStartTime.split(' ')[0]+' '+temp[1]+':00';
                        if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                            flag=true;
                            return flag;
                        }
                    }
                    let dayNum2=moment(this.callEndTime).format('d');
                    dayNum2=Number(dayNum2)+1;
                    if(this.callStartTime.split(' ')[0] != this.callEndTime.split(' ')[0]) {
                        let unavailabilityList2=unavailabilityList[dayNum2];
                        for(var i=1; i<=Object.keys(unavailabilityList2).length; i++){
                            var temp = unavailabilityList2[i];
                            var start = this.callEndTime.split(' ')[0]+' '+temp[0]+':00';
                            var end = this.callEndTime.split(' ')[0]+' '+temp[1]+':00';
                            if(dateTimeConvert.dateCheck(start, end, this.callStartTime, this.callEndTime)){
                                flag=true;
                                return flag;
                            }
                        }
                    }
                }
                return flag;
            },

            checkVacationWithinCall(vacations) {
                // Conditions modified by Srabani on 23.11.2018
                if(vacations.length>0){
                    //console.log('vacations',vacations);
                    // var startDate = vacations[0].start;
                    // var endDate = vacations[0].end;

                    // if(dateTimeConvert.dateCheck(startDate, endDate, this.callStartTime) || dateTimeConvert.dateCheck(startDate, endDate, this.callEndTime)){
                    //     //console.log('true',vacations);
                    //     return true;
                    // }
                    // return false;
                    return true;
                }
                return false;


                // for (let i = 0; i < vacations.length; i++) {
                //     var startTime = vacations[i].start.split(" ")[1];
                //     var endTime = vacations[i].end.split(" ")[1];
                //     if (dateTimeConvert.checkTimeIsbetween(startTime, endTime, this.callStartTime) && dateTimeConvert.checkTimeIsbetween(startTime, endTime, this.callEndTime)) {
                //         return true;
                //     }
                // }
                // return false;
            },

            checkElement(fieldName){
                console.log(fieldname);
                for (var key in this.callAssigmentSettings) {
                    if(this.callAssigmentSettings[key]==fieldName){
                        return true;
                    }
                }
                return false;
            },
            async jobDetails() {
                // this.job=JSON.parse(JSON.stringify(this.getJob));
                // this.jobTitle = this.job.title;
                await service.get('job/' + atob(this.$route.params.id), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    //console.log("Job details", res);
                    //this.$store.dispatch('setJob', res.data.result);
                    // this.title = res.data.result.title;
                    this.job=res.data.result;

                    this.jobTitle = this.job.title;

                    this.isSteward = this.job.employee_id==this.employeeId&&this.isSteward ? 1 : 0;

                    this.isDispatcher = this.job.dispatched_by.id == this.userID&&this.isDispatcher ? 1 : 0;
                    // this.setJobTimeout(this.job.timeout);
                    // this.$Progress.finish();
                    // this.getRefs();
                }).catch((err) => {
                    console.log(err);
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
            },

            sortDynamic(type){

                switch(type){
                    case "employee_name":
                        if(this.selectedSortType=='fname_asc'){
                            this.selectedSortType='lname_asc';
                        }else{
                            this.selectedSortType='fname_asc';
                        }
                        break;

                    case "skill_seniority":
                        if(this.selectedSortType=='skill_seniority'){
                            this.selectedSortType='skill_seniority_desc';
                        }else{
                            this.selectedSortType='skill_seniority';
                        }
                        break;

                    case "employee_seniority":
                        if(this.selectedSortType=='emp_seniority'){
                            this.selectedSortType='emp_seniority_desc';
                        }else{
                            this.selectedSortType='emp_seniority';
                        }
                        break;

                    case "shift_count_total":
                        if(this.selectedSortType=='shift_total_asc'){
                            this.selectedSortType='shift_total_desc';
                        }else{
                            this.selectedSortType='shift_total_asc';
                        }
                        break;

                    case "shift_count_ytd":
                        if(this.selectedSortType=='shift_YTD_asc'){
                            this.selectedSortType='shift_YTD_desc';
                        }else{
                            this.selectedSortType='shift_YTD_asc';
                        }
                        break;

                    case "shifts_this_week":
                        if(this.selectedSortType=='shift_weekly_asc'){
                            this.selectedSortType='shift_weekly_desc';
                        }else{
                            this.selectedSortType='shift_weekly_asc';
                        }
                        break;

                    case "shifts_ytd_july_june":
                        if(this.selectedSortType=='shift_july_june_asc'){
                            this.selectedSortType='shift_july_june_desc';
                        }else{
                            this.selectedSortType='shift_july_june_asc';
                        }
                        break;

                    case "declines_total":
                        if(this.selectedSortType=='decline_total__asc'){
                            this.selectedSortType='decline_total__desc';
                        }else{
                            this.selectedSortType='decline_total__asc';
                        }
                        break;

                    case "declines_ytd":
                        if(this.selectedSortType=='decline_YTD_asc'){
                            this.selectedSortType='decline_YTD_desc';
                        }else{
                            this.selectedSortType='decline_YTD_asc';
                        }
                        break;

                    case "declines_ytd_july_june":
                        if(this.selectedSortType=='decline_july_june_asc'){
                            this.selectedSortType='decline_july_june_desc';
                        }else{
                            this.selectedSortType='decline_july_june_asc';
                        }
                        break;

                    case "decline_this_week":
                        if(this.selectedSortType=='decline_weekly_asc'){
                            this.selectedSortType='decline_weekly_desc';
                        }else{
                            this.selectedSortType='decline_weekly_asc';
                        }
                        break;

                    case "employee_cell_phone":
                        if(this.selectedSortType=='phone_asc'){
                            this.selectedSortType='phone_desc';
                        }else{
                            this.selectedSortType='phone_asc';
                        }
                        break;

                    case "conflicts":
                        if(this.selectedSortType=='conflicts_asc'){
                            this.selectedSortType='conflicts_desc';
                        }else{
                            this.selectedSortType='conflicts_asc';
                        }
                        break;

                    case "location":
                        if(this.selectedSortType=='location_asc'){
                            this.selectedSortType='location_desc';
                        }else{
                            this.selectedSortType='location_asc';
                        }
                        break;

                    case "last_offer":
                        if(this.selectedSortType=='last_offer_asc'){
                            this.selectedSortType='last_offer_desc';
                        }else{
                            this.selectedSortType='last_offer_asc';
                        }
                        break;

                    case "last_assigned":
                        if(this.selectedSortType=='last_assigned_asc'){
                            this.selectedSortType='last_assigned_desc';
                        }else{
                            this.selectedSortType='last_assigned_asc';
                        }
                        break;

                    case "last_confirmed":
                        if(this.selectedSortType=='last_confirmed_asc'){
                            this.selectedSortType='last_confirmed_desc';
                        }else{
                            this.selectedSortType='last_confirmed_asc';
                        }
                        break;

                    case "participation":
                        if(this.selectedSortType=='participation_asc'){
                            this.selectedSortType='participation_desc';
                        }else{
                            this.selectedSortType='participation_asc';
                        }
                        break;

                    case "participation_july_june_desc":
                        if(this.selectedSortType=='participation_july_june_desc'){
                            this.selectedSortType='participation_july_june_asc';
                        }else{
                            this.selectedSortType='participation_july_june_desc';
                        }
                        break;

                    case "wishlist":
                        if(this.selectedSortType=='wishlist_asc'){
                            this.selectedSortType='wishlist_desc';
                        }else{
                            this.selectedSortType='wishlist_asc';
                        }
                        break;

                    case "custom_field1":
                        if(this.selectedSortType=='custom_field1_asc'){
                            this.selectedSortType='custom_field1_desc';
                        }else{
                            this.selectedSortType='custom_field1_asc';
                        }
                        break;

                    case "custom_field2":
                        if(this.selectedSortType=='custom_field2_asc'){
                            this.selectedSortType='custom_field2_desc';
                        }else{
                            this.selectedSortType='custom_field2_asc';
                        }
                        break;

                    case "member_since":
                        if(this.selectedSortType=='member_since_asc'){
                            this.selectedSortType='member_since_desc';
                        }else{
                            this.selectedSortType='member_since_asc';
                        }
                        break;

                    case "date_of_hire":
                        if(this.selectedSortType=='date_of_hire_asc'){
                            this.selectedSortType='date_of_hire_desc';
                        }else{
                            this.selectedSortType='date_of_hire_asc';
                        }
                        break;
                }
                this.getEmployeesBySkill();
            },


            pollData () {
                this.polling = setInterval(() => {
                    // console.log(document.visibilityState);
                    // document.addEventListener('visibilitychange', () => {
                        if(document.visibilityState === 'visible'){
                            this.timerState = "Started"
                        }else {
                            this.timerState = "Paused"
                        }
                    // })


                    if (this.timerState === "Started") {
                        // console.log("Call Api");
                        this.getEmployeesBySkill();
                    }
                }, 60000);
            }
        },

        async created() {
            this.loading = true;
            await this.checkDispatcherSkill();
            await this.checkStewardSkill();
            await this.jobDetails();
            this.getBaseURL = global[0].IMAGE_URL;
            if(this.job) {
                document.title = `${this.job.job_number}#${this.job.title}`;
            }

            this.client=JSON.parse(JSON.stringify(this.clientDetails));
            if(this.client){
                this.turnoverTime= this.client.turnover;
                this.selectedSortType= this.client.default_sort;
                this.customField1 =  this.client.custom_field_1;
                this.customField2 = this.client.custom_field_2;
                this.showCustom = this.client.employee_title;
                this.callAssigmentSettings = this.client.settings['call-assignment-config'];
                this.statusSortType = this.client.assign_page_default_status;
            }

            // console.log(this.callAssigmentSettings);

            // let phoneIndex = this.callAssigmentSettings.findIndex((ele) => ele == 'employee_cell_phone');
            // // console.log(phoneIndex);
            // if(phoneIndex < 0) {
            //     this.callAssigmentSettings.push('employee_cell_phone');
            // }

            this.statusList = JSON.parse(JSON.stringify(this.employeeStatusList));
            if(this.statusSortType == 'all'){
                this.selectedStatusId='';
            }else if(this.statusSortType == 'priority'){
                this.selectedStatusId = this.statusList.length ? this.statusList[0].id : '';
                this.tempStatus = this.selectedStatusId;
            }

            // if(this.getAssignPageStatus.uid == this.userID){
            //     this.selectedStatusId=this.getAssignPageStatus.status;
            // }else if(this.getAssignPageStatus.uid != this.userID || this.selectedStatusId ==''){
            //     this.selectedStatusId =this.statusList[0].id;
            // }
            this.onChangeStatus();

            bus.$on('changeSort', (data) => {
                //this.skillData = data;
                this.sortDynamic(data);
                //console.log("Emit fire..",data);
            });

            bus.$on('callUnDecline', (decline) => {
                // console.log(decline);
                this.getEmployeesBySkill();
            });
            // this.pollData();
            this.getEmpDetails();
        },

        mounted(){
            // document.getElementById('page-data-focus').focus();
            let self = this;
            // document.getElementById('assign-emp-search').focus();
            $(window).on('keydown', function(e) {
                if(e.keyCode === 40){
                    document.getElementById('page-data-focus').focus();
                    e.preventDefault();
                    self.onPageChangeScrollDown();
                }else if(e.keyCode === 38){
                    document.getElementById('page-data-focus').focus();
                    e.preventDefault();
                    self.onPageChangeScrollUp();
                }
                // console.log(e.keyCode);
            });
            var totalHeight = $('.o-header').height() + $('.table_header_wrapper').height()+100;
            var windowHeight = $(window).height();
            var adjustedHeight = windowHeight - totalHeight;
            if(adjustedHeight<250){
              $('.tbl-content').css('height', 200);
            }else{
              $('.tbl-content').css('height', adjustedHeight);
            }
            $("#fc_frame").css('display', 'none');

            //right content positioning on sidebar click expand
            // $('.o-sidebar-trigger.js-sidebarTrigger').on('click', function(e) {
            //     var con = $('.o-sidenav.mainSidenav').hasClass('open');
            //     var wrap = $('.table_header_wrapper.sticky_header');
            //     var c = 'animate_header';
            //     var temp = con ? wrap.addClass(c) : wrap.removeClass(c);
            // });
        },

        beforeDestroy(){
            $("#fc_frame").css('display', 'block');
            $(window).off('keydown');
            bus.$off('changeSort');
            $('.v--modal-overlay.scrollable').css('overflow-y','auto');
            // clearInterval(this.polling);
        },

    }


</script>
<style scoped>
.v--modal-overlay.scrollable{
    overflow-y: auto!important;
}
.o-common-modal-content {
    border-radius: 3px !important;
    padding: 0px!important;
    background-color: #ffffff;
    border: 2px solid #000000!important;
}

.modal-title {
    padding: 5px;
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    background-color: #F67801;
    border-bottom: 2px solid #000000;
}

.close {
    text-shadow: 0 0 0 #000000!important;
    font-size: 15px;
}

.custom-modal--close {
    opacity: 1;
    position: absolute;
    right: 10px;
    top: 8px;
    font-size: 20px;
    width: 20px;
    height: 20px;
    background-color: #F67801!important;
    color: #000000!important;
    padding: 0 !important;
    text-shadow: #000000!important;
    margin-top: 0;
}

.obt-modal-cancel-btn {
    background-color: #F67801;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}
.obt-modal-proceed-btn {
    background-color: #17A068;
    color: #ffffff;
    margin-right: 20px;
    padding: 10px 15px;
}

.obt-conflict-body {
    line-height: 1.5;
    font-size: 15px;
    font-weight: 500;
    padding: 10px 10px 0;
}

.display-inline{
    display: flex;
}

.global-skill-display {
    font-size: 13px;
    font-weight: 500;
    width: 24px;
    height: 24px;
    color: #000;
    background-color: #F67801;
    text-align: center;
}

#assign-emp-search:focus {
    border: 2px solid #337ab7;
}
#assign-emp-sort:focus {
    border: 2px solid #337ab7;
}
#selectedStatus:focus {
    border: 2px solid #337ab7;
}
.select_margin_adjust{
    width: 230px;
}
.table_tagline p {
    font-size: 18px;
}

</style>
